import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_DC_PATIENT_SKILLACQ_GRAPH_API = `${API_URL}/api/CollectData/GetPatientSkillsAcquisitionGraphs`;
export const GET_DC_PATIENT_BEHAVIOUR_GRAPH_API = `${API_URL}/api/CollectData/GetPatientBehaviorsReductionGraphs`;
export const GET_TARGETSANDPROGRAMSDATA_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetProgramsAndTargetsByPatientId`;
export const GET_BEHAVIORREDUCTIONSDATA_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReductionByPatientId`;

export const DataCollectionGraphActionTypes = {
    get_DC_PatientSkillAcqGraphAPI: createRequestActionTypes('GET_DC_PATIENT_SKILLACQ_GRAPH_API'),
    get_DC_PatientBehaviourGraphAPI: createRequestActionTypes('GET_DC_PATIENT_BEHAVIOUR_GRAPH_API'),
    get_TargetsAndProgramsData: createRequestActionTypes('GET_TARGETSANDPROGRAMSDATA'),
    get_BehaviorsReductionsData: createRequestActionTypes('GET_BEHAVIORREDUCTIONSDATA'),
    set_GraphAnnotationAndBaselineBlank: createRequestActionTypes('SET_GRAPHANNOTATIONANDBASELINEBLANK'),
    set_GraphAnnotationValue: createRequestActionTypes('SET_GRAPHANNOTATIONVALUE'),
    set_GraphBaselineValue: createRequestActionTypes('SET_GRAPHBASELINEVALUE'),
};

export const MODULE = 'DCMASTER_DATAANALYTICS';


// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/DataCollectionGraph/constants/ApiConstants.js